<template>
  <VRow v-if="localLoading && !prepared" no-gutters>
    <Preloader />
  </VRow>
  <VCard v-else class="int-card">
    <VCardText>
      <VCol
        cols="12"
        sm="10"
        md="10"
        lg="10"
        class="mx-auto mb"
      >
        <RegistrationForm
          :company="company"
          :user="user"
          :action="registerCompany"
          @registered="next"
        />
      </VCol>
    </VCardText>
  </VCard>
</template>

<script>
import useValidation from '@/compositions/useValidation';
import useIntegrations from '@/compositions/useIntegrations';
import { reactive, ref } from '@vue/composition-api';
import Preloader from '@/components/Preloader';
import RegistrationForm from '@/forms/RegistrationForm';

export default {
  name: 'IntegrationsWizardRegistration',
  components: {
    Preloader,
    RegistrationForm,
  },
  setup(props, { emit }) {
    const {
      errors,
      errorMessage,
      hasErrorMessageOnly,
      localLoading,
      withValidationHandling,
    } = useValidation();
    const { fetchAll, getRegistrationData, registerCompany } = useIntegrations();
    const data = reactive({
      company: {},
      user: {},
    });
    const prepared = ref(false);

    async function loadRegistrationData() {
      await withValidationHandling(async () => {
        const response = await getRegistrationData();
        data.company = Object.assign(data.company, response.company);
        data.user = Object.assign(data.user, response.user);
        prepared.value = true;
      });
    }

    loadRegistrationData();

    async function next() {
      fetchAll();
      emit('next');
    }

    return {
      next,
      errors,
      errorMessage,
      hasErrorMessageOnly,
      localLoading,
      company: data.company,
      user: data.user,
      registerCompany,
      prepared,
    };
  },

};
</script>

<style lang="scss" scoped>
  .int-card.v-card {
    max-width: 53rem;
    border-radius: 0.625rem;
    text-align: center;
    margin: 0 auto;
    &:not(.v-sheet--outlined) {
      box-shadow: 0px 0.5rem 1rem rgba(0, 0, 0, 0.04);
      margin-bottom: 1.25rem;
    }
  }
  .int-image {
    padding: 3.4375rem 0 3px;
  }
  .int-text-email {
    line-height: 1.53;
    text-align: center;
    color: #091A35;
    margin-bottom: 2rem;
  }
  .int-text-field {
    max-width: 21.625rem;
    margin: 0 auto;
  }

  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .int-card.v-card {
      max-width: 40rem;
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .int-image {
      padding-top: 2rem;
    }
    .int-text-email {
      margin-bottom: 1.5rem;
    }
  }
</style>
